// src/FlutterwavePayment.js - Flutterwave Integration (USD)
//import React from 'react';
//import { CreditCard, Check, Crown, X } from 'lucide-react';
//import { SUBSCRIPTION_PLANS } from './SubscriptionSystem';

// Flutterwave public key (Get this from Flutterwave dashboard)
// For testing, use TEST key. For production, use LIVE key
const FLUTTERWAVE_PUBLIC_KEY = process.env.REACT_APP_FLUTTERWAVE_KEY;// Your live key

// Check if Flutterwave script is already loaded
const isFlutterwaveLoaded = () => {
  return typeof window !== 'undefined' && window.FlutterwaveCheckout !== undefined;
};

export const initiateFlutterwavePayment = (email, amount, plan, userName, onSuccess, onClose) => {
  // If Flutterwave is already loaded, use it directly
  if (isFlutterwaveLoaded()) {
    openFlutterwaveModal(email, amount, plan, userName, onSuccess, onClose);
    return;
  }

  // Load Flutterwave inline script
  const existingScript = document.querySelector('script[src="https://checkout.flutterwave.com/v3.js"]');
  
  if (existingScript) {
    existingScript.onload = () => {
      openFlutterwaveModal(email, amount, plan, userName, onSuccess, onClose);
    };
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://checkout.flutterwave.com/v3.js';
  script.async = true;
  
  script.onload = () => {
    console.log('Flutterwave script loaded successfully');
    openFlutterwaveModal(email, amount, plan, userName, onSuccess, onClose);
  };

  script.onerror = (error) => {
    console.error('Failed to load Flutterwave script:', error);
    alert('Failed to load payment system. Please check your internet connection and try again.');
    onClose();
  };

  document.body.appendChild(script);
};

const openFlutterwaveModal = (email, amount, plan, userName, onSuccess, onClose) => {
  try {
    if (!window.FlutterwaveCheckout) {
      throw new Error('Flutterwave not loaded');
    }

    const modal = window.FlutterwaveCheckout({
      public_key: FLUTTERWAVE_PUBLIC_KEY,
      tx_ref: 'SUB_' + Date.now() + '_' + Math.floor(Math.random() * 1000000),
      amount: amount / 100, // Convert cents to dollars
      currency: 'USD',
      payment_options: 'card,banktransfer,ussd,account',
      customer: {
        email: email || 'user@example.com',
        name: userName || 'Subscriber',
      },
      meta: {
        subscription_plan: plan,
      },
      customizations: {
        title: 'Subscription Payment',
        description: `Payment for ${plan} subscription`,
        logo: 'https://beconstores.com/wp-content/uploads/2021/07/fashion-designer-template-product-img-2-600x800.jpg', // Optional: Add your logo URL
      },
      callback: function(response) {
        console.log('Payment successful:', response);
        modal.close();
        
        // Verify payment was successful
        if (response.status === 'successful') {
          onSuccess(response);
        } else {
          alert('Payment verification failed. Please contact support.');
          onClose();
        }
      },
      onclose: function() {
        console.log('Payment modal closed');
        onClose();
      }
    });
  } catch (error) {
    console.error('Error opening Flutterwave modal:', error);
    alert('Error: ' + error.message + '\n\nPlease make sure you have set up your Flutterwave API key correctly.');
    onClose();
  }
};





